export default {
  namespaced: true,
  state: {
    startDateDF: "",
    startDateSM: "",
  },
  mutations: {
    setStartDateDF: (state, date) => {
      state.startDateDF = date;
    },
    setStartDateSM: (state, date) => {
      state.startDateSM = date;
    },
  },
  actions: {
    setStartDateDF: (context, date) => {
      context.commit("setStartDateDF", date);
    },
    setStartDateSM: (context, date) => {
      context.commit("setStartDateSM", date);
    },
  },
};
